module.exports = __webpack_public_path__ + "static/media/gb3.0e654caf.JPG";